<form [formGroup]="form" (ngSubmit)="connectLocationsWithSiteGroupId()">
  <h1 mat-dialog-title translate="add-account/site-group"></h1>
  <div mat-dialog-content>
    <p class="description" translate="add-account/site-group/description"></p>

    <mat-radio-group formControlName="siteGroupOptions">
      <mat-radio-button data-testid="link-no-group" value="no-group">
        <span translate="add-account/site-group/no-group"></span>
      </mat-radio-button>
      <div class="select-group">
        <mat-radio-button data-testid="link-select-group" value="select-group">
          <span translate="add-account/site-group/select-group"></span>
        </mat-radio-button>
        <mat-form-field>
          <mat-label translate="accounts/group"></mat-label>
          <mat-select data-testid="select-site-group" formControlName="siteGroupId">
            <mat-option
              [attr.data-testid]="'select-site-group-label-' + item.id"
              *ngFor="let item of data.siteGroups"
              [value]="item.id"
              >{{ item.label }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="create-group-name">
        <mat-radio-button data-testid="link-create-group" value="create-group">
          <span translate="add-account/site-group/create-group"></span>
        </mat-radio-button>
        <mat-form-field>
          <mat-label translate="add-account/site-group/create-group/name"></mat-label>
          <input data-testid="link-site-group-name" type="text" matInput formControlName="siteGroupName" />
        </mat-form-field>
      </div>
    </mat-radio-group>
  </div>
  <div mat-dialog-actions>
    <button
      data-testid="submit-link-group"
      type="submit"
      mat-raised-button
      color="primary"
      translate="ok"
      [disabled]="form.invalid"></button>
    <button
      data-testid="cancel-link-group"
      type="button"
      mat-dialog-close
      mat-raised-button
      translate="cancel"></button>
  </div>
</form>
